




import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class VolverButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
